export const LOCATION_LOADING = "LOCATION_LOADING";
export const GET_LOCATION_BY_STATE = "GET_LOCATION_BY_STATE";
export const REMOVE_LOCATION_DATA = "REMOVE_LOCATION_DATA";
